@for (percentage of value(); let i = $index; track i) {
  <div class="bar" [style.height.%]="percentage"></div>
}
